import { observer } from "mobx-react";
import type TableCardStore from "../TableCardStore";
import AcxSelectSingle from "components/UI/Select/BaseSelectComponents/AcxSelectSingle";

type LLMClassifierControlProps = {
    store: TableCardStore;
};

const ExtractionLlmClassifierControl = observer(
    ({ store }: LLMClassifierControlProps) => {
        const llmOptions = store.optionsStore.extractionLlmClassifiers;
        const metadataOptions =
            store.optionsStore.extendedMetadataObjectClassifiers;

        const llmOptionsLoading =
            store.optionsStore.extractionLlmClassifiersLoading;
        const metadataOptionsLoading =
            store.optionsStore.extendedMetadataObjectClassifiersLoading;

        const selectedLlmClassifier = llmOptions.find(
            (llmClassifier) =>
                llmClassifier.id === store.selectedIds.extractionLlmClassifier,
        );

        const metadataOptionsForSelectedLlmClassifier = !selectedLlmClassifier
            ? []
            : metadataOptions.filter((o) =>
                  selectedLlmClassifier.potentialExtendedMetadataClassifierIds.includes(
                      o.id,
                  ),
              );

        return (
            <>
                <AcxSelectSingle
                    id="select-model"
                    valueField="id"
                    labelField="name"
                    fullWidth
                    options={llmOptions}
                    defaultValue={selectedLlmClassifier}
                    onChange={(llmClassifier) => {
                        store.setSelectedId(
                            "extractionLlmClassifier",
                            llmClassifier?.id,
                        );
                        void store.handleSelectionChange();
                    }}
                    placeholder="Select model"
                    isLoading={llmOptionsLoading}
                />
                <AcxSelectSingle
                    id="select-metadata"
                    valueField="id"
                    labelField="name"
                    fullWidth
                    options={metadataOptionsForSelectedLlmClassifier}
                    defaultValue={metadataOptions.find(
                        (metadata) =>
                            metadata.id ===
                            store.selectedIds.extendedMetadataObjectClassifier,
                    )}
                    onChange={(metadata) => {
                        store.setSelectedId(
                            "extendedMetadataObjectClassifier",
                            metadata?.id,
                        );
                        void store.handleSelectionChange();
                    }}
                    placeholder="Select metadata field"
                    isLoading={metadataOptionsLoading}
                />
            </>
        );
    },
);

export default ExtractionLlmClassifierControl;
